export const SIGNUP_EXPERIMENT_FLAG_KEY = "signup-email-first-v1"
export const SIGNUP_EXPERIMENT_CONTROL_VARIANT = "control"
export const SIGNUP_EXPERIMENT_VARIANT = "email_first"

export type SignupExperimentVariant = typeof SIGNUP_EXPERIMENT_CONTROL_VARIANT | typeof SIGNUP_EXPERIMENT_VARIANT

export function normalizeSignupExperimentVariant(value: unknown): SignupExperimentVariant {
  if (value === SIGNUP_EXPERIMENT_VARIANT) {
    return SIGNUP_EXPERIMENT_VARIANT
  }

  if (value === SIGNUP_EXPERIMENT_CONTROL_VARIANT) {
    return SIGNUP_EXPERIMENT_CONTROL_VARIANT
  }

  return SIGNUP_EXPERIMENT_CONTROL_VARIANT
}
